import script from "./VideoPlayerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoPlayerPage.vue?vue&type=script&setup=true&lang=js"

import "./VideoPlayerPage.vue?vue&type=style&index=0&id=3fe27c4e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fe27c4e"]])

export default __exports__